import { Navigate } from "react-router-dom";
import { lazy } from "react";
import MainLayout from "../layout/mainLayout";

const LoginPage = lazy(() => import("../Pages/login"));
const LiveTrackingPage = lazy(() => import("../Pages/liveTracking/index.jsx"));
const ForgotPage = lazy(() => import("../Pages/forgot"));
const Home = lazy(() => import("../Pages/Home/home"));
const Pickup = lazy(() => import("../Pages/pickUp/pickUp"));
const Delivery = lazy(() => import("../Pages/delivery/delivery"));

export const commonRoutes = [

  {
    path: "/",
    element: <Navigate to="/home" replace />
  },

  {
    path: "/login",
    element: <LoginPage />,
  },

  {
    path: "/login/:deleteStatus",
    element: <LoginPage />,
  },

  {
    path: "/liveTracking/:lat/:lng/:channelId/:orderId/:type",
    element: <LiveTrackingPage />,
  },

  {
    path: "/forgot-password",
    element: <ForgotPage />,
  },

  {
    element: <MainLayout />,
    children: [
      { path: "home", element: <Home /> },
      { path: "pickup", element: <Pickup /> },
      { path: "delivery", element: <Delivery /> },
    ],
  },

  {
    path: "*",
    element: <Navigate to="/home" replace />
  }

]
